import React, { useCallback } from "react";
import { Alert, Linking, Text, TouchableOpacity } from "react-native";
import { theme } from "../../theme/theme";
import { messages } from "../../resources/strings";

const OpenURLButton = ({
  url,
  children,
}: {
  url: string;
  children: React.ReactNode;
}) => {
  const handlePress = useCallback(async () => {
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
    } else {
      Alert.alert(`${messages.error.badURL} ${url}`);
    }
  }, [url]);

  return (
    <TouchableOpacity
      style={{ marginHorizontal: theme.margin.reg }}
      onPress={handlePress}
      testID={`login-page-footer-${children?.toLowerCase()?.replaceAll(" ","-")}-button`}
    >
      <Text
        style={{
          color: theme.colors.white,
          fontSize: theme.fontsize.reg,
          fontFamily: theme.fontFamily.robotoRegular,
        }}
        testID={`login-page-footer-${children?.toLowerCase()?.replaceAll(" ","-")}-label`}
      >
        {children}
      </Text>
    </TouchableOpacity>
  );
};

export default OpenURLButton;
